import Head from 'next/head';
import styles from './PrivacyPolicy.module.scss';

export default function PrivacyPolicy() {
  return (
    <>
      <Head>
        <title>Privacy Policy</title>
        <meta name="description" content="VuSocial Privacy Policy" />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <div className={styles.headingImageContainer}>
        <div className={styles.headingOverlay}>
          <div className={styles.container}>
            <h1 className={styles.mainHeading}>Privacy Policy</h1>
          </div>
        </div>
      </div>

      <div className={styles.contentContainer}>
        <div className={styles.divider}></div>

        <p>
          <span className={styles.brandText}>roomvu.com</span>&trade; has
          established this Privacy Policy to explain how it protects and manages
          the personal information that it collects from you (the customer)
          online.
          <br />
          roomvu.com may change this policy from time to time by updating this
          page. It is recommended that you check this page from time to time to
          ensure that you are aware and comfortable with any changes. This
          policy is effective from the 1st July 2018.
        </p>

        <h2 id="h.cygfhddor8ch">
          1 Consent for Collection, Use and Disclosure
        </h2>
        <p>
          Your use of the roomvu.com site and/or your registration for
          roomvu.com products and services constitute your consent to the terms
          of this Privacy Policy. If you do not agree to the terms of this
          Privacy Policy, please do not use the roomvu.com site.
          <br />
          roomvu.com may occasionally update this Privacy Policy. When it does,
          roomvu.com will also revise the &quot;last update&quot; date at the
          top of this Privacy Policy. In addition, roomvu.com will seek a
          customer&#39;s prior consent, by email, for any new uses or proposed
          disclosures of information collected from the customer prior to the
          change. roomvu.com will notify customers by email of changes to this
          policy that will affect information collected from them in the future.
          In certain circumstances, however, roomvu.com will not inform and
          obtain the consent of the customer, such as in connection with an
          investigation of a breach of an agreement, contravention of laws, an
          emergency where the life, health or security of an individual is
          threatened, the collection of a debt or in compliance with the request
          of a law enforcement agency or a court order.
          <br />A customer may withdraw his or her consent for collection, use
          and disclosure at any time by sending an email to info@roomvu.com.
          Please note that, if you do, roomvu.com may suspend its provision of
          products and services to you.
        </p>

        <h2 id="h.gqpajmns8twk">2 Accountability</h2>
        <p>
          <span className={styles.brandText}>roomvu.com</span>&nbsp;collects, at
          the time of your registration and your sign-on to its web site,
          certain &quot;personal information&quot;(information that personally
          identifies you) including but not limited to your name, email address,
          address, telephone number, and information about your computer
          hardware and software (e.g., IP address, operating system, browser
          type, domain name, URL, access times, and referring web site
          addresses).
          <br />
          roomvu.com has implemented this Privacy Policy to protect personal
          information received from its customers, and to respond to any
          inquiries. The Privacy Policy also provides that roomvu.com will use
          appropriate contractual means to establish a comparable level of
          protection for personal information which is sent for processing by
          third parties on roomvu.com&#39;s behalf.
          <br />
          roomvu.com has designated responsibility for your personal information
          to its Privacy Officer, who ensures compliance with the principles in
          this Privacy Policy. Other roomvu.com individuals may be delegated to
          act on behalf of the Privacy Officer.
        </p>

        <h2 id="h.jr0mspmnd3yc">
          3 Purposes for Collecting Personal Information
        </h2>
        <ol start={1}>
          <li>
            <span className={styles.brandText}>roomvu.com</span>&nbsp;collects
            and uses personal information for the following Identified Purposes:
            <br />
            to understand customer needs regarding roomvu.com&#39;s services;
          </li>
          <li>
            to develop and provide our web site and our products and services
            for our customers;
          </li>
          <li>
            to fulfill your requests for products, services or information;
          </li>
          <li>
            to communicate with customers and site visitors, when necessary, and
            to inform customers of upgrades, as well as of other products and
            services available from roomvu.com, its affiliates and third
            parties;
          </li>
          <li>
            to allow customers to access limited-entry areas of roomvu.com&#39;s
            site;
          </li>
          <li>
            to personalize some of our services and products for you and to
            deliver targeted advertisements and offers from roomvu.com and third
            parties;
          </li>
          <li>to bill accounts and maintain payment records;</li>
          <li>
            to comply with any applicable law, regulation, legal process or
            government request;
          </li>
          <li>
            to respond to a legitimate claim, or to address our reasonable
            belief, that you are violating the rights of any third party or any
            of the agreements or policies that govern your use of the roomvu.com
            site or any roomvu.com product or service;
          </li>
          <li>
            to protect the services, products or rights of roomvu.com, including
            but not limited to the security or integrity of the roomvu.com site;
            and
          </li>
          <li>
            to identify and resolve technical problems concerning
            roomvu.com&#39;s site, products and services.
            <br />
            roomvu.com also uses personal information in an aggregate form
            (i.e., not individually attributable to you) for its business
            analysis, operational, marketing and other promotional purposes.
            <br />
            If we hire other companies to provide some products or services on
            our behalf, then we will only provide those companies the personal
            information they need for the Identified Purposes, and we will limit
            their rights to use and further disclose your personal information
            as appropriate in the course of their work for us.
          </li>
        </ol>

        <h2 id="h.nezkx8gobkn0">
          4 Limiting the Collection of Personal Information
        </h2>
        <p>
          <span className={styles.brandText}>roomvu.com</span> limits its
          collection of personal information to only that information which is
          necessary for the Identified Purposes. roomvu.com does not direct its
          site to, nor does it knowingly collect any personal information from
          children under the age of thirteen.
          <br />
          When you visit the roomvu.com web site, a cookie may be placed on your
          computer or the cookie may be read if you have visited the roomvu.com
          site previously. roomvu.com uses cookies to allow roomvu.com to
          determine which products and services you have already accepted so
          that roomvu.com does not provide redundant information to you, and, if
          you are an roomvu.com affiliate, to track roomvu.com sales made to
          customers referred by you so that you can receive compensation under
          an affiliate program. If you choose to not have your browser accept
          cookies from the roomvu.com web site, you may not be able to view all
          the text on the screens, or to experience a personalised visit, or to
          subscribe to certain service and product offerings on the roomvu.com
          site.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </p>

        <h2 id="h.a5qr776qxuxm">5 Disclosure, Processing and Retention</h2>
        <p>
          roomvu.com does not sell, rent or disclose your personal information
          to anyone else, except:
        </p>
        <ol start={1}>
          <li>
            to someone you have designated to act as your agent, for one or more
            of the Identified Purposes (listed in Section 2, above);
          </li>
          <li>
            to roomvu.com&#39;s employees, independent contractors,
            subsidiaries, affiliates, consultants, business associates, service
            providers, suppliers and agents, acting on roomvu.com&#39;s behalf
            for any of the Identified Purposes;
          </li>
          <li>
            as necessary if roomvu.com has reason to believe that disclosure is
            necessary to identify, contact or bring legal action against someone
            who may be causing injury to or interference (either intentionally
            or unintentionally) with roomvu.com&#39;s rights or property, other
            users of roomvu.com&#39;s web site, products or services, or anyone
            else that could be harmed by such activities; and
          </li>
          <li>
            to respond to judicial process and provide information to law
            enforcement agencies or in connection with an investigation on
            matters related to public safety, as permitted by law, or otherwise
            as required by law.
            <br />
            In addition, as we continue to develop our business, we or our
            affiliates may sell or buy other businesses or entities, or we may
            merge with another company. In such transactions, personal
            information may be one of the transferred business assets. Also, in
            the event that roomvu.com or substantially all of its assets are
            acquired, your personal information may be one of the transferred
            assets.
          </li>
        </ol>
        <p>
          <br />
          Your information may be stored and processed in the United States, or
          in any other country in which roomvu.com or its affiliates,
          subsidiaries or agents maintain facilities. By using this web site,
          you consent to any such transfer of information outside of your
          country.
          <br />
          After your account becomes inactive (that is, if you request to be
          removed from our database), roomvu.com will keep your personal
          information in its archives. Your information will then be used only
          as necessary for tax reasons or to prove roomvu.com&#39;s compliance
          with any applicable law.
        </p>

        <h2 id="h.xphdfd8ac83a">6 Links to other websites</h2>
        <p>
          Our website may contain links to other websites of interest. However,
          once you have used these links to leave our site, you should note that
          we do not have any control over that other website. Therefore, we
          cannot be responsible for the protection and privacy of any
          information which you provide whilst visiting such sites and such
          sites are not governed by this privacy statement. You should exercise
          caution and look at the privacy statement applicable to the website in
          question.
        </p>

        <h2 id="h.fkcd41rs864o">7 Accuracy of Personal Information</h2>
        <p>
          roomvu.com will use reasonable efforts to keep customer personal
          information accurate for the Identified Purposes, and for minimizing
          the possibility of making inappropriate customer decisions based on
          such information. Customers are responsible for informing roomvu.com
          about changes to their personal information. You can do this by
          calling 888-712-3607 or sending an email to our privacy department.
          roomvu.com will use new or updated personal information it receives
          from customers to update its own records.
        </p>

        <h2 id="h.k33frfu9uiz8">8 Data Security</h2>
        <p>
          At Roomvu network (including VuSocial), we prioritize the security and
          confidentiality of your data. We implement strict security measures
          and best practices to ensure that all user information remains
          protected from unauthorized access, loss, or misuse.
        </p>

        <h2 id="h.8ud5n2l0sk1m">9 Access to Personal Information</h2>
        <p>
          <span className={styles.brandText}>roomvu.com</span>&nbsp;will afford
          you a reasonable opportunity to review the personal information in
          your file, if you so request by writing to:
        </p>
        <p>
          <br />
          Roomvu network (including VuSocial).com <br />
          226-970 Burrard <br />
          Vancouver, BC <br />
          V6Z 0C5 <br />
          Canada
        </p>
        <p>
          <br />
          If roomvu.com is not able to provide access to some aspect of a
          customer&#39;s personal information, it will provide reasons for
          denying access such as; that by doing so would likely reveal personal
          information about a third party, or that it is confidential commercial
          information or attorney-client privileged communications, or that the
          information relates to a breach of an agreement or a contravention of
          law, or that its disclosure could reasonably be expected to threaten
          the life or security of another individual.
          <br />
          Customers have the right to request that inaccurate or incomplete
          information be amended as appropriate, by contacting roomvu.com or the
          Privacy Officer as described above. roomvu.com will promptly correct
          such personal information.
        </p>
        <p>
          If your non-identifiable data are used for research purposes, then the
          limitation of liability and indemnity clauses contained within the End
          User License Agreement/Terms of Service Agreement are waived with
          respect to any harms suffered or liabilities incurred as a result of
          any research activities.
        </p>
        <p>
          <br />
          For any further information, please don&#39;t hesitate to contact us
          at info@roomvu.com <br />
        </p>

        <h2 id="h.k33frfu9uiz8">10 Opt-Out and Applications Date Usage</h2>
        <p>
          You may &quot;opt-out&quot; of receiving promotional emails from
          roomvu by following the instructions in those emails. You may also
          send requests relating to promotional messages and your permission for
          sharing information with third parties for their marketing purposes by
          emailing info@roomvu.com. Opt-out requests will not apply to
          transactional service messages, including messages about your current
          roomvu account and services. You may also choose to remove the
          Authentication provided to Us from your Facebook or Twitter account.
        </p>

        <h2 id="h.k33frfu9uiz8">
          11 Your rights in relation to your Personal Information
        </h2>
        <p>
          Roomvu network (including VuSocial) believes that it is imperative
          that all roomvu users have control over their Personal Information.
          Therefore, depending on the way you use the Roomvu network (including
          VuSocial) Services, you may have the right to request access to,
          receive a copy of, update, amend or delete, port certain Personal
          Information to another service, restrict, or object to certain uses of
          your Personal Information (for example, for direct marketing
          purposes). Further, when we rely on your consent for processing of
          your Personal Information (for instance, for direct marketing) you can
          withdraw your consent at any time, and such withdrawal will take
          affect from thereon.
        </p>
        <p>
          Roomvu network (including VuSocial) will not charge you more if you
          exercise any of these rights and will continue to provide you with the
          same level of service.
        </p>
        <p>
          If you are a Roomvu network (including VuSocial) user, you can access
          and correct a lot of your Personal Information directly through your
          account, or via online forms roomvu makes available to you (as
          detailed below). You can also exercise your rights by sending your
          request to info@roomvu.com, mailing it to roomvu.com, unit 226, 970
          Burrard St, Vancouver, BC, Canada., or reaching out to our customer
          care department. When we receive your right request, we may take steps
          to verify your identity before complying with the request to protect
          your privacy and security.
        </p>
        <p>
          Before fulfilling your request, we may ask you for additional
          information in order to confirm your identity and for security
          purposes. We reserve the right to charge a fee where permitted by law
          (e.g. if your request is unfounded or excessive).
        </p>
        <p>
          Please note that permanently deleting your Roomvu network (including
          VuSocial) account erases all of your Personal Information from
          roomvu&#39;s databases. After completing this process, you can no
          longer use any of your Roomvu network (including VuSocial) Services,
          your account and all its data will be removed permanently, and Roomvu
          network (including VuSocial) will not be able to restore your account
          or retrieve your data in the future.
        </p>

        <h2 id="h.k33frfu9uiz8">12 Third Party Privacy Policies</h2>
        <p>
          For various services across roomvu.com we may use uses YouTube API
          Services, with Terms of Service found{' '}
          <a
            href="https://www.youtube.com/t/terms"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>
          .
        </p>
        <p>
          For various services across roomvu.com we may use uses Google API
          Services, with their Terms of Service found{' '}
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>
          .
        </p>
        <p>
          For various services across roomvu.com we may use uses Google API
          Google security settings services to get user revoking API
          Client&#39;s access to their data. with their Terms of Service found{' '}
          <a
            href="https://myaccount.google.com/permissions"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>
          .
        </p>

        <h2 id="h.k33frfu9uiz8">13 YouTube Privacy policy</h2>
        <p>
          By using Roomvu network (including VuSocial) product, If you are
          connecting your YouTube channel to Roomvu network (including
          VuSocial), you are agreeing to be bound by the YouTube terms of
          Service. (
          <a
            href="https://www.youtube.com/t/terms"
            target="_blank"
            rel="noopener noreferrer"
          >
            Link
          </a>
          )
        </p>

        <h2 id="h.k33frfu9uiz8">14 SMS</h2>
        <p>
          SMS Terms & Conditions:
          <br />
          By subscribing to Roomvu network (including VuSocial) SMS services,
          you agree to receive text messages from us. Roomvu network (including
          VuSocial) will send SMS messages to update customers on project
          statuses and enhance the overall customer experience. For assistance,
          please contact us at info@roomvu.com. To opt out, reply
          &quot;STOP&quot; at any time. Message frequency may vary, and standard
          message and data rates may apply.
          <br />
          <br />
          Text/SMS Marketing:
          <br />
          If you opt into SMS communications from Roomvu network (including
          VuSocial), you will receive text messages at the number provided.
          These may include promotional offers, coupons, and updates related to
          Roomvu network (including VuSocial) or our affiliated businesses,
          along with order and account information.
          <br />
          <br />
          Consent to Receive Automated Messages:
          <br />
          Your consent to receive automated messages is not a condition for
          purchasing or using Roomvu network (including VuSocial) services.
          Messages may include order confirmations, updates, and special offers.
          <br />
          <br />
          Frequency of Messages:
          <br />
          Message frequency may vary based on orders, account activity, and
          promotions. Messages will include transactional updates and occasional
          promotional content.
          <br />
          <br />
          Opt-Out and Support Options:
          <br />
          To stop receiving text messages, text &quot;STOP&quot; at any time.
          Once your opt-out request is processed, you will no longer receive
          messages from us. A confirmation message will be sent upon
          unsubscribing. To re-subscribe, text &quot;START.&quot; For
          assistance, text &quot;HELP&quot; or contact us at info@roomvu.com
          <br />
          <br />
          Wireless Carrier Rates and Services:
          <br />
          Standard message and data rates may apply. Wireless carriers are not
          responsible for delayed or undelivered messages.
          <br />
          <br />
          Confidentiality:
          <br />
          We will keep your mobile number confidential and will not share it
          with third parties for marketing purposes. However, for operational
          purposes, your name and number may be shared with service providers
          who facilitate SMS communications. These providers will use your
          information solely for delivering these services.
          <br />
          No mobile information will be shared with third parties for
          marketing/promotional purposes. The privacy policy excludes text
          messaging originator opt-in data and consent, which will not be shared
          with third parties. Users can opt out by replying &quot;STOP&quot; or
          request more information by replying &quot;HELP.&quot; Message
          frequency may vary, and standard rates may apply.
        </p>
      </div>
    </>
  );
}
